const stageMap: Map<string, string> = new Map([
  ["beta.asin-central.loom.devices.amazon.dev", "beta"],
  ["asin-central.loom.devices.amazon.dev", "prod"],
]);

function getStage() {
  if (typeof window !== "undefined") {
    const hostName = window.location.hostname;
    if (!stageMap.has(hostName)) {
      return "test";
    }
    return stageMap.get(hostName);
  }
  // Default to prod. This is necessary since server-side rendering will call this, and if it's not
  // set to "prod", then the isProdStage() function will return false, rendering elements that are
  // not ready for prod yet.
  return process.env.STAGE || "prod";
}

export function isServer() {
  return typeof window === "undefined";
}

export function isProdStage() {
  return getStage() === "prod";
}

export function isBetaStage() {
  return getStage() === "beta";
}

export function isTestStage() {
  return getStage() === "test";
}

export function isPersonalStack() {
  if (typeof window !== "undefined") {
    const hostName = window.location.hostname;
    return hostName.includes("test-");
  }
  return false;
}
